import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initWebVitals } from "./utils/webVitals";
import { initCrawlerLogging } from "./utils/crawlerLogger";
import { initAnalytics } from "./utils/analytics";

// Initialize analytics (gtag.js is loaded but events only fire after consent)
initAnalytics();

// Initialize Web Vitals monitoring
initWebVitals();

// Initialize crawler logging
initCrawlerLogging();

const container = document.getElementById("root")!;

// The build prerenders real markup into #root (see scripts/prerenderPlugin.ts).
// Hydrate it when present so users see the same content crawlers get.
// In dev the container only holds the <!--app-html--> comment, which is a child
// node but not rendered markup — hydrating that fails, so require an element.
if (container.firstElementChild) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
}

